import * as httpHelper from '../httpHelper';//网络助手

/** 获取分类列表 */
export function getContentList(params) {
  return httpHelper.get('getContentList',params);
}

/** 获取分类树 */
export function getContentById(params) {
  return httpHelper.get('getContentById',params);
}

/** 获取新闻详情 */
export function getContentById2(params) {
  return httpHelper.getNewDetail('getContentById',params);
}